import { redirect } from '@hooks'
import { createFileRoute } from '@tanstack/react-router'

const Preferences = redirect('/settings/configuration')

export const Route = createFileRoute('/preferences/')({
  component: Preferences,
})
